import LegalLayout from "@/pages/LegalLayout";

const H2 = ({ children }) => (
  <h2 className="mb-2.5 mt-8 text-[18px] font-medium text-brand-ink">{children}</h2>
);

export default function AvisoLegal() {
  return (
    <LegalLayout title="Aviso legal">
      <H2>1. Datos identificativos</H2>
      <p>
        En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la
        Información y de Comercio Electrónico (LSSI-CE), se informa de que este sitio web,
        asistentesvirtual.com (en adelante, «el Sitio Web»), es titularidad de:
      </p>
      <ul className="mb-3.5 mt-2 list-disc pl-6">
        <li>Titular: [NOMBRE Y APELLIDOS o RAZÓN SOCIAL]</li>
        <li>NIF/CIF: [NIF O CIF]</li>
        <li>Domicilio: [DIRECCIÓN COMPLETA]</li>
        <li>Correo electrónico: hola@asistentesvirtual.com</li>
        <li>Teléfono: [TELÉFONO]</li>
      </ul>

      <H2>2. Objeto</H2>
      <p>
        El Sitio Web tiene por objeto informar sobre los servicios de asistencia virtual y
        secretariado remoto ofrecidos por el titular, así como facilitar el contacto con
        clientes potenciales.
      </p>

      <H2>3. Condiciones de uso</H2>
      <p>
        El acceso y uso del Sitio Web atribuye la condición de usuario e implica la aceptación
        de las presentes condiciones. El usuario se compromete a hacer un uso adecuado de los
        contenidos y a no emplearlos para actividades ilícitas o contrarias a la buena fe y al
        ordenamiento legal.
      </p>

      <H2>4. Propiedad intelectual e industrial</H2>
      <p>
        Todos los contenidos del Sitio Web (textos, imágenes, logotipos, diseño y código fuente)
        son titularidad del titular o de terceros que han autorizado su uso, y están protegidos
        por la normativa de propiedad intelectual e industrial. Queda prohibida su reproducción,
        distribución o comunicación pública sin autorización expresa.
      </p>

      <H2>5. Responsabilidad</H2>
      <p>
        El titular no se hace responsable del mal uso que se realice de los contenidos del Sitio
        Web ni de los daños derivados de fallos técnicos ajenos a su control. Los precios y
        condiciones mostrados tienen carácter informativo y pueden ser modificados sin previo
        aviso; la oferta definitiva será la recogida en la propuesta o contrato entregado a cada
        cliente.
      </p>

      <H2>6. Enlaces a terceros</H2>
      <p>
        El Sitio Web puede contener enlaces a sitios de terceros. El titular no asume
        responsabilidad alguna sobre sus contenidos o políticas.
      </p>

      <H2>7. Legislación aplicable</H2>
      <p>
        Las presentes condiciones se rigen por la legislación española. Para cualquier
        controversia, las partes se someten a los juzgados y tribunales del domicilio del
        usuario, cuando la normativa de consumidores así lo disponga, o en su defecto a los de
        [CIUDAD].
      </p>
    </LegalLayout>
  );
}
